import styled from 'styled-components';

export const Container = styled.div`
  max-width: 100vw;
  display: flex;
  .header {
    display: flex;
    flex-direction: column;

    h1 {
      font-size: 2rem;
      line-height: 1.5;
      font-weight: 500;
      color: ${({ theme }) => theme.colors.secondary};
    }

    .headerDateRangePicker {
      width: 22.5rem;

      button {
        display: flex;
        gap: 0.3rem;
        margin: 1.25rem 0;
        color: ${({ theme }) => theme.colors.text_gray};
        border: 1px solid ${({ theme }) => theme.colors.text_gray};
        border-radius: 16px;
        padding: 0.5rem;
      }
    }
  }

  @media (max-width: 1000px) {
    margin: 2rem;
  }

  @media (max-width: 330px) {
    .header .headerDateRangePicker {
      width: 100%;
    }
  }
`;
export const Content = styled.div``;
